export default __webpack_public_path__ + "static/media/world-golden.701116d6.svg";